"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleConfigurationFields = exports.vehicleModelFields = exports.imageFields = exports.vehicleFields = void 0;
exports.vehicleFields = `
  id
  interior
  name
  price
  priceExcludingVat
  packages {
    name
    packages
  }
  pricing {
    customerAdvantage
    customerPrice
    extraDeliveryCharge    
    extraImporterSupport
    extraOneTimeFee
    extraWreckage
    indicativePrice
    leasingBasisPrice
    leasingInterestRate
    loanInterestRate
    margin
    netCustomerPrice
    netCustomerPriceIncludingVat
    remainder3630
    remainder3645
    retailerMargin
    retailerSupport
  }
  accessories {
    articleNumber
    customerPrice
    dealershipPrice
    id
    images {
      url
    }
    manufacturer
    margin
    name
    price
  }
  model {
    make
    bodywork {
      name
      type
    }
    fuel {
      name
      type
    }
    varnishes {
      id
      additionalPrice
      additionalPriceExcludingVat
      hexCode
      name
      varnishType
    }
    images {
      url
    }
    name
  }
  tires {
    id
    name
    nobosCode
    price
    rimManufacturer
    tireManufacturer
    tireType
    type
  }
`;
exports.imageFields = `
  altText
  caption
  height
  url
  variants {
    altText
    caption
    height
    url
    width
  }
  width
`;
exports.vehicleModelFields = `
  id
  name
  make
  images {
    ${exports.imageFields}
  }
  vehicleType
  series
  salesArticle
  fuel {
    name
    type
  }
  powerTrain
  effect
  electricProps {
    batteryCapacity
    chargingCapacityAC
    chargingCapacityDC
    electricRange
  }
  towingCapacity
  equipment {
    name
    equipment
  }
  pricing {
    deliveryCharge
    importerSupport
    oneTimeFee
    source
    wreckage
  }
  bodywork {
    name
    type
  }
`;
exports.vehicleConfigurationFields = `
  id
  name
  price
  sku
  images {
    ${exports.imageFields}
  }
  model {
    ${exports.vehicleModelFields}
  }
  salesPackages {
    id
    name
    additionalPrice
    equipment
  }
  optionPackages {
    id
    name
    additionalPrice
    equipment
  }
  tires {
    id
    name
    images {
      ${exports.imageFields}
    }
    rimManufacturer
    tireManufacturer
    nobos
    type
    description
    additionalPrice
    isRecommended
  }
  varnishes {
    id
    name
    varnishCode
    type
    hexCode
    additionalPrice
    isRecommended
  }
  interiors {
    id
    name
    images {
      ${exports.imageFields}
    }
    interiorCode
    type
    additionalPrice
    isRecommended
  }
  rims
  accessories {
    id
    name
    price
    sku
    images {
      ${exports.imageFields}
    }
    manufacturer
    customerPrice
    retailPrice
    margin
  }
  pricing {
    customerAdvantage
    customerPrice
    extraDeliveryCharge
    extraImporterSupport
    extraOneTimeFee
    extraWreckage
    indicativePrice
    leasingBasisPrice
    leasingInterestRate
    loanInterestRate
    margin
    netCustomerPrice
    remainder3630
    remainder3645
    retailerMargin
    retailerSupport
  }
  electricProps {
    extraEffect
    extraElectricRange
    extraBatteryCapacity
  }
`;
//# sourceMappingURL=vehicle.js.map